import GenericSlider from './generic-slider';

export default class GenericSliderDesktop extends GenericSlider {
}
